import { del, post, postMultiFile } from './request';
import { IAudioDetails } from 'types/audio';

export interface AudioManagementResponse {
  result: string;
  error?: string;
  audio?: IAudioDetails;
}

export const deleteAudioReference = async (
  ref: number,
  refId: number,
  dialectId: number,
): Promise<AudioManagementResponse | undefined> => {
  try {
    const response = await del<AudioManagementResponse>(`/audio/${ref}/${refId}/dialect/${dialectId}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.error || 'Failed to delete audio reference');
  }
};

export const recoverAudio = async (
  ref: number,
  refId: number,
  dialectId: number,
): Promise<AudioManagementResponse | undefined> => {
  try {
    const response = await post<AudioManagementResponse>(`/audio/${ref}/${refId}/dialect/${dialectId}/recover`, {});
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.error || 'Failed to recover audio');
  }
};

export const uploadAudio = async (
  ref: number,
  refId: number,
  dialectId: number,
  file: File,
): Promise<AudioManagementResponse | undefined> => {
  const response = await postMultiFile<AudioManagementResponse | { error: string }>(
    `/audio/${ref}/${refId}/dialect/${dialectId}/upload`,
    [{ fileName: 'audio', file }],
  );

  // Check if response contains an error
  if (response.data && 'error' in response.data) {
    throw new Error(response.data.error);
  }

  if (!response.data) {
    throw new Error('Failed to upload audio');
  }

  return response.data as AudioManagementResponse;
};

export const canManageAudio = (audio: IAudioDetails): boolean => {
  return !(audio.audioSet && audio.audioSet.active);
};

export const getAudioSetRestrictionMessage = (audio: IAudioDetails): string => {
  if (audio.audioSet && audio.audioSet.active) {
    return `This audio belongs to the active audio set "${audio.audioSet.name}" and cannot be modified.`;
  }
  return '';
};
